import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SbBadgeComponent } from './sb-badge.component';

const COMPONENTS = [
  SbBadgeComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
  ],
})
export class SbBadgeModule { }
